<template>
	<div class="page__account-bar" v-if="userLogedIn">
		<div class="container">
			<div class="account-menu" v-if="userLogedIn">
				<div class="account-menu__item" v-if="isRacePage && !isMobile">
					<div class="race__date">
						{{ raceDateText }}
					</div>
				</div>
				<div class="account-menu__item account-menu__item--account account-menu__item--waiting">
					<router-link :to="{name: 'User'}" class="account-menu__link">
						<span class="icon icon--user-circle account-menu__item__icon" aria-hidden="true"></span>
						<div class="acount-menu__text">{{ user.firstname }} {{ user.lastname }}</div>
					</router-link>
				</div>
				<div class="account-menu__item">
					<router-link :to="{name: 'User'}" class="account-menu__link">
						<span class="icon icon--money-circle account-menu__item__icon" aria-hidden="true"></span>
						<div class="acount-menu__text"><b>Solde</b> {{ formatToMoney(user.balance) }}
						</div>
					</router-link>
				</div>
				<div class="account-menu__item" v-if="isRacePage">
					<router-link
							:to="{ name: 'TimelineWithDate', params: {date: formatToDate(race.details.time)}, query: { premium: true } }"
							class="btn btn--small btn--primary">
						{{t('timeline.button.fill.program')}}
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Vuex from 'vuex';
	import moment from 'moment-timezone';

	export default {
		name: 'AccountBar',
		components: {

		},
		data() {
			return {

			}
		},
		computed: {
			...Vuex.mapState([
				'lang'
			]),
			...Vuex.mapGetters({
				user: 'getUser',
				userLogedIn: 'getUserStatus',
				race: 'currentRace'
			}),
			isRacePage(){

				return this.$route.name === "Race" || this.$route.name === "RaceById";
			},
			raceDateText() {
				if (this.race.details) {
					return moment(this.race.details.time).format('DD MMMM YYYY [-] H[h]mm')
				}
			},
		},
		watch: {
		},
		mounted() {

		},
		methods: {
			formatToDate(date) {
				return moment(date).format('YYYY-MM-DD');
			},
		}
	}
</script>